

















export type PauseBehavior = 'skip' | 'silence';

export const PauseBehavior = {
    Skip: 'skip' as PauseBehavior,
    Silence: 'silence' as PauseBehavior
}
